import { useRef, useEffect } from "react";
import * as echarts from "echarts";
import { Stack, Tooltip } from "@mui/material"; // Assuming you're using Material-UI

const ComplianceCellRenderer = (params: any) => {
  const chartRef = useRef(null);
  
  // Ensure we have a valid number between 0 and 100
  let value = 0;
  if (typeof params.value === 'number') {
    value = Math.round(params.value);
  } else if (typeof params.value === 'string') {
    value = Math.round(parseFloat(params.value.replace('%', '')));
  }
  value = isNaN(value) ? 0 : Math.min(Math.max(value, 0), 100);

  console.log('ComplianceCellRenderer - Raw Value:', params.value);
  console.log('ComplianceCellRenderer - Processed Value:', value);

  useEffect(() => {
    if (chartRef.current) {
      const chartInstance = echarts.init(chartRef.current, null, {
        renderer: "svg",
      });
      const option = {
        animation:false,
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            label: { show: false },
            labelLine: { show: false },
            emphasis: {
              scale: false,
            },
            data: [
              { value: value, itemStyle: { color: "#00A61B" } },
              { value: 100 - value, itemStyle: { color: "#C0BFD5" } },
            ],
          },
        ],
      };

      chartInstance.setOption(option);
      return () => chartInstance.dispose();
    }
  }, [value]);

  return (
  <Tooltip
  arrow
  title={`${value}%`}
  slotProps={{
    popper: {
      sx: {
        "& .MuiTooltip-tooltip": {
          backgroundColor: "#fff",
          color: "#000",
          fontSize: "0.75rem",
          border: "1px solid #ddd",
          boxShadow: 2,
          whiteSpace: "normal",
          wordBreak: "break-word",
        },
        "& .MuiTooltip-arrow": {
          color: "#fff",
        },
      },
    },
  }}
>
  <Stack direction="row" alignItems="center" className="ag-center">
    <div ref={chartRef} style={{ width: "30px", height: "30px" }} />
    <span>{value}%</span>
  </Stack>
</Tooltip>

  );
};

export default ComplianceCellRenderer;
